import axios, { AxiosPromise } from 'axios';
import {
  WatcherWithoutDocuments,
  WatcherEntityItem,
  WatcherSearchQuery,
  WatcherEntitySearchQuery,
  WatcherDocument,
  WatcherSearchQueryEnum,
  WatcherWithoutDocumentsWithCounts,
} from './watchers.types';

export async function fetchWatchers(params?: {
  from?: number;
  size?: number;
}): Promise<Array<WatcherWithoutDocumentsWithCounts>> {
  return (await axios.get('/watchers', { params })).data;
}

export async function createWatcherRequest(
  queries: Array<WatcherSearchQuery | WatcherEntitySearchQuery>,
): Promise<WatcherWithoutDocuments & { alreadyExists?: boolean }> {
  return (await axios.post('/watchers/queries', [...queries])).data;
}

export async function createQueriesOnWatcherRequest(
  key: string,
  queries: Array<WatcherSearchQuery | WatcherEntitySearchQuery>,
): Promise<WatcherWithoutDocuments> {
  return (await axios.post(`/watchers/${key}/queries`, [...queries])).data;
}

export function deleteQueryOnWatcherRequest(
  key: string,
  type: WatcherSearchQueryEnum,
): Promise<{}> {
  return axios.delete(`/watchers/${key}/queries/${type}`);
}

export function deleteWatcherRequest(key: string): Promise<{}> {
  return axios.delete(`/watchers/${key}`);
}

export async function fetchWatcherContent(
  key: string,
  params?: {
    from: number;
    size: number;
  },
): Promise<Array<WatcherDocument>> {
  return (await axios.get(`/watchers/${key}/documents`, { params })).data;
}

export async function fetchWatcher(
  key: string,
): Promise<WatcherWithoutDocumentsWithCounts> {
  return (await axios.get(`/watchers/${key}`)).data;
}

export function markAllWatcherDocumentsAsRead(
  key: string,
): AxiosPromise<{ key: string }> {
  return axios.patch(`/watchers/${key}/documents`, { isRead: true });
}

export function getUserWatchers(): AxiosPromise<Array<WatcherEntityItem>> {
  return axios.get('/watchers/entities');
}

// TODO : remove route (only kept for retro compatibility)
export async function openedWatcher(key: string): Promise<Array<number>> {
  return (await axios.post('/opened_watcher', { key })).data;
}
